import React from "react";
import "./noQuestions.css";

const NoQuestions = () => {
  return (
    <div className="no-questions-container">
      <div className="no-questions-icon-wrapper">
        <svg className="no-questions-icon" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="32" cy="32" r="28" stroke="currentColor" strokeWidth="2.5" strokeDasharray="6 4" />
          <path d="M24 26c0-4.418 3.582-8 8-8s8 3.582 8 8c0 3.6-2.4 6-5.333 7.2C33.333 31.6 32 33.2 32 35" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
          <circle cx="32" cy="41" r="1.5" fill="currentColor" />
        </svg>
      </div>
      <p className="no-questions-title">No Prediction Questions</p>
      <p className="no-questions-subtitle">Check back later for upcoming match questions</p>
    </div>
  );
};

export default NoQuestions;
